import React from "react";
import ActionCard from "components/ActionCard";
import { ReactComponent as HelpIcon } from "icons/help/question-greybg.svg";
import { ReactComponent as UniversityIcon } from "icons/help/university-greybg.svg";
import { ReactComponent as DocumentationIcon } from "icons/help/lifesaver-greybg.svg";
import { ReactComponent as DictionaryIcon } from "icons/help/book-greybg.svg";

const getCta = (url, text) => (
  <a href={url} target="_blank" rel="noreferrer">
    {text}
  </a>
);

const HelpActionCards = () => (
  <>
    <h2>Help Links</h2>
    <section className="help__action_cards">
      <ActionCard
        image={<HelpIcon />}
        header="Need Help?"
        description="Ask a question on any aspect of VisibleThread"
        cta={getCta(
          "https://support.visiblethread.com/hc/en-us/requests/new",
          "Ask A Question"
        )}
      />
      <ActionCard
        image={<UniversityIcon />}
        header="VT University"
        description="Get VT Docs certification, enroll in our free online courses"
        cta={getCta(
          "https://www.visiblethread.com/vt-university/",
          "Enroll Today"
        )}
      />
      <ActionCard
        image={<DocumentationIcon />}
        header="Help Documentation"
        description="Read online Product Documentation"
        cta={getCta(
          "https://support.visiblethread.com/hc/en-us/categories/201832466-VisibleThread-Docs",
          "View Documentation"
        )}
      />
      <ActionCard
        image={<DictionaryIcon />}
        header="Dictionary Marketplace"
        description='Get access to free "Search Dictionaries"'
        cta={getCta(
          "https://www.visiblethread.com/marketplace/",
          "Go To Marketplace"
        )}
      />
    </section>
  </>
);

export default HelpActionCards;
